(() => {
  const dialog = document.getElementById('zyn-exit-offer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const storageKey = 'zynaero-offer-dismissed-v1';
  const started = Date.now();
  let shown = false;
  let previousFocus;
  let suppressed = false;
  try { suppressed = Date.now() - Number(localStorage.getItem(storageKey) || 0) < 7 * 86400000; } catch (_) {}
  if (suppressed) return;
  const open = () => {
    if (shown || document.visibilityState !== 'visible' || document.querySelector('dialog[open]')) return;
    if (Date.now() - started < 20000) return;
    shown = true;
    previousFocus = document.activeElement;
    dialog.showModal();
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
  };
  document.addEventListener('mouseout', event => {
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches && !event.relatedTarget && event.clientY <= 0) open();
  }, {passive:true});
  let scrolled = false;
  const maybeMobile = () => {
    if (!window.matchMedia('(hover:none), (pointer:coarse)').matches) return;
    const available = document.documentElement.scrollHeight - window.innerHeight;
    if (available > 0 && window.scrollY / available >= .5) scrolled = true;
    if (scrolled && Date.now() - started >= 30000) open();
  };
  window.addEventListener('scroll', maybeMobile, {passive:true});
  window.setTimeout(maybeMobile, 30000);
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-offer-close]') || event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus(); });
})();
